module.exports = __webpack_public_path__ + "img/dhurata-07.762db92b.svg";